import type { ReactNode } from 'react';
import { Stack, type StackProps } from '@src/components/Stack/Stack';
import { PageContent } from '@src/components/PageContent/PageContent';
import './LandingLayout.css';
export function LandingContent({ children, testId }: { children: ReactNode; testId?: string }) {
  return (
    <PageContent className="landing-content" testId={testId}>
      <div className="landing-flow">{children}</div>
    </PageContent>
  );
}
export function LandingSection({
  variant = 'ground',
  continueLandscape = false,
  ...props
}: StackProps & { variant?: 'hero' | 'ground' | 'faq' | 'cta'; continueLandscape?: boolean }) {
  return (
    <Stack
      {...props}
      as="section"
      className={`landing-section landing-section--${variant}${continueLandscape ? ' landscape-continuation-anchor' : ''}`}
    />
  );
}
export function LandingActions({ children }: { children: ReactNode }) {
  return <div className="landing-actions">{children}</div>;
}
export function LandingMoreLink({ children }: { children: ReactNode }) {
  return <div className="landing-more-link">{children}</div>;
}
export function ExchangeGrid({ children, columns = 5 }: { children: ReactNode; columns?: 4 | 5 }) {
  return <div className={`exchange-grid exchange-grid--${columns}`}>{children}</div>;
}

/** Foreground content planted in the hero landscape. */
export function LandingScenery({ children }: { children: ReactNode }) {
  return <div className="landing-scenery">{children}</div>;
}

/** Keep an opening form above the explanatory sections and landscape edge. */
export function LandscapeIntro({ children }: { children: ReactNode }) {
  return <div className="landscape-intro">{children}</div>;
}
